const destination = 'G-BQSWDB36J3';
const allowedEvents = new Set(['nt_shipping_quote_start', 'nt_shipping_quote_result', 'nt_gallery_view']);
const allowedParameters = new Set(['interaction_location', 'quote_status', 'rate_count', 'lowest_rate', 'free_shipping', 'currency', 'duration_ms', 'image_index', 'interaction_method']);

if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') {
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
}

function track(name, parameters = {}) {
  if (window.Shopify?.designMode || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return false;
  if (typeof window.gtag !== 'function') return false;
  const product = location.pathname.match(/\/products\/([a-z0-9-]+)/)?.[1];
  try {
    window.gtag('event', name, {
      ...parameters,
      send_to: destination,
      page_type: document.querySelector('#MainContent')?.dataset.template?.split('.')[0] || 'other',
      ...(product ? { product_handle: product } : {}),
    });
    return true;
  } catch {
    return false;
  }
}

document.addEventListener('nt:interaction', (event) => {
  const { name, parameters = {} } = event.detail || {};
  if (!allowedEvents.has(name)) return;
  const safe = {};
  for (const [key, value] of Object.entries(parameters)) {
    if (!allowedParameters.has(key)) continue;
    if (typeof value === 'string') safe[key] = value.slice(0, 80);
    else if (typeof value === 'boolean' || (typeof value === 'number' && Number.isFinite(value))) safe[key] = value;
  }
  track(name, safe);
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[href]');
  if (link) {
    const url = new URL(link.href, location.origin);
    if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') {
      track('nt_whatsapp_click', {
        interaction_location: link.closest('.nt-pdp__ajuda') ? 'product_help'
          : link.closest('.nt-zap') ? 'floating'
          : link.closest('footer') ? 'footer' : 'content',
      });
    }
  }
  const details = event.target.closest('[data-nt-detalhe-botao]');
  if (details?.getAttribute('aria-expanded') === 'true') {
    track('nt_product_details', { detail_name: details.textContent.trim().slice(0, 80) });
  }
});

const played = new WeakSet();
document.addEventListener('play', (event) => {
  const video = event.target;
  if (!(video instanceof HTMLVideoElement) || !video.closest('.nt-pdp__videos') || played.has(video)) return;
  if (track('nt_product_video_start', {
    video_index: [...video.closest('.nt-pdp__videos').querySelectorAll('video')].indexOf(video) + 1,
  })) played.add(video);
}, true);
